import React from "react";

const Breadcrumb = ({ title = "Page Title", path = [] }) => {
  return (
    <div className="site-breadcrumb">
      <div className="container">
        <h2 className="breadcrumb-title">{title}</h2>
        <ul className="breadcrumb-menu">
          {path.map((item, index) => (
            <li key={index} className={item.active ? "active" : ""}>
              {item.active ? (
                item.label
              ) : (
                <a href={item.href}>{item.label}</a>
              )}
            </li>
          ))}
        </ul>
      </div>
      <div className="hero-shape">
        <img
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
          className="hero-shape-1"
          src="/assets/img/shape/03.svg"
          alt=""
        />
        <img
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
          className="hero-shape-2"
          src="/assets/img/shape/05.svg"
          alt=""
        />
        <img
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
          className="hero-shape-3"
          src="/assets/img/shape/06.svg"
          alt=""
        />
        <img
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
          className="hero-shape-4"
          src="/assets/img/shape/07.svg"
          alt=""
        />
      </div>
    </div>
  );
};

export default Breadcrumb;
